import gsap from "gsap";
import { animateObserver, fadeIn, opacityDelayBetweenItems } from "../../../js/animations/animations";
import { isAuthor, isMobile } from "../../../js/utils";

(() => {
  const brhGallery = {
    callback: function ($el) {
      const url = $el.querySelector("[data-link]").getAttribute("data-link");
      const brhRenditionBreakpoints = $el.querySelector("[data-image-rendition-breakpoints]")?.getAttribute("data-image-rendition-breakpoints");
      fetch(url)
        .then((res) => res.text())
        .then((content) => {
          const parser = new DOMParser();
          const response = parser.parseFromString(content, "text/html");
          const brhItems = Array.from(response.querySelectorAll(".brh-gallery__item .cmp-image")).slice(0, 9);
          const brhItemsCopy = brhItems.map((item) => item.cloneNode(true));

          brhItems.forEach((item) => {
            const slide = document.createElement("div");
            slide.classList.add("swiper-slide");
            item.classList = "brh-gallery__swiper-slide-item";
            brhRenditionBreakpoints && (item.dataset.renditionBreakpoints = brhRenditionBreakpoints);
            slide.append(item);
            $el.querySelector(".brh-gallery__swiper-preview .swiper-wrapper").append(slide);
          });
          brhItemsCopy.forEach((item) => {
            const slide = document.createElement("div");
            slide.classList.add("swiper-slide");
            item.classList = "brh-gallery__swiper-slide-item";
            slide.append(item);
            if ($el.classList.contains("brh-gallery-room")) {
              $el.querySelector(".brh-gallery__swiper-thumbs .swiper-wrapper").append(slide);
            } else {
              $el.querySelector(".brh-gallery__swiper .swiper-wrapper").append(slide);
            }
          });

          if ($el.classList.contains("brh-gallery-room")) {
            const swiperThumbs = new window.Swiper($el.querySelector(".brh-gallery__swiper-thumbs"), {
              slidesPerView: 5,
              direction: "horizontal",
              spaceBetween: 0,
              loop: false,
              freeMode: false,
              watchSlidesProgress: true,
              allowTouchMove: true,
              centeredSlides: true,
              centeredSlidesBounds: true,
              centerInsufficientSlides: true,
            });

            new window.Swiper($el.querySelector(".brh-gallery__swiper-preview"), {
              thumbs: {
                swiper: swiperThumbs,
              },
              navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
              },
            });
          } else {
            if ($el.closest(".brh-slide-gallery")) {
              const swiperThumbs = new window.Swiper($el.querySelector(".brh-gallery__swiper"), {
                slidesPerView: "auto",
                spaceBetween: 10,
              });

              new window.Swiper($el.querySelector(".brh-gallery__swiper-preview"), {
                autoplay: {
                  delay: 2000,
                  disableOnInteraction: false,
                },
                thumbs: {
                  swiper: swiperThumbs,
                },
                pagination: {
                  el: ".swiper-pagination",
                  clickable: "true",
                  type: "bullets",
                  renderBullet: function (index, className) {
                    return `<span class="${className}"> <span class="${className}__container"></span> <b class="${className}__progress-bar"></b> </span>`;
                  },
                },
                navigation: {
                  nextEl: ".swiper-button-next",
                  prevEl: ".swiper-button-prev",
                },
              });
            } else {
              const swiperThumbs = new window.Swiper($el.querySelector(".brh-gallery__swiper"), {
                slidesPerView: "auto",
              });

              new window.Swiper($el.querySelector(".brh-gallery__swiper-preview"), {
                thumbs: {
                  swiper: swiperThumbs,
                },
                navigation: {
                  nextEl: ".swiper-button-next",
                  prevEl: ".swiper-button-prev",
                },
              });
            }
          }
          this.handleButtons($el);
        });
    },

    handleButtons: function ($el) {
      if (!$el.classList.contains("brh-gallery-room")) {
        const fullThumbsWidth = parseInt(getComputedStyle($el.querySelector(".brh-gallery__swiper")).width);
        const thumbsWidth = parseInt(getComputedStyle($el.querySelector(".brh-gallery__swiper .swiper-wrapper")).width);
        $el.querySelector(".swiper-button-next").style.right = (fullThumbsWidth - thumbsWidth) / 2 + "px";
        $el.querySelector(".swiper-button-prev").style.left = (fullThumbsWidth - thumbsWidth) / 2 + "px";
      }
    },
  };

  const BRHGallery = () => {
    const selectors = {
      component: ".brh-gallery",
    };

    const init = () => {
      const parentElement = Array.from(document.querySelectorAll(selectors.component));
      if (parentElement) {
        parentElement.forEach((element) => {
          brhGallery.callback(element);
          window.addEventListener("resize", () => brhGallery.handleButtons(element));
        });
      }

      //== Animations
      if (!isMobile() && !isAuthor()) {
        if (parentElement.length > 0) {
          parentElement?.forEach((element) => {
            const appearances = gsap.timeline();
            const slider = element.querySelector(".brh-gallery__swiper-preview");
            slider && appearances.add(fadeIn({ classElement: slider, duration: 2 }), 0);

            setTimeout(() => {
              const thumbs = element.querySelectorAll(".brh-gallery__swiper .swiper-slide");
              thumbs?.length > 0 && appearances.add(opacityDelayBetweenItems({ classElement: thumbs, duration: 2 }), 0);
            }, 400);
            appearances.pause();

            animateObserver({ elementToObserve: element, animation: () => appearances, threshold: 0 });
          });
        }
      }
    };
    init();
  };
  document.addEventListener("DOMContentLoaded", BRHGallery);
})();
